export default class BudgetActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static GET_HELPER ='GET_HELPER';
    static RESET_LIST ='RESET_LIST';
    static REJECT_DATA="REJECT_DATA";
    static APPROVE_DATA="APPROVE_DATA";

    static submit(){
      return {
        type: BudgetActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: BudgetActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: BudgetActions.UPDATE_DATA,
        payload: data
      };
    }

     static approve() {
      return {
        type: BudgetActions.APPROVE_DATA,
      };
    }

    static reject() {
      return {
        type: BudgetActions.REJECT_DATA,
      };
    }
  
    static view(data) {
      return {
        type: BudgetActions.VIEW_DATA,
        payload: data
      };
    }
  
    static void(data) {
      return {
        type: BudgetActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: BudgetActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: BudgetActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: BudgetActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: BudgetActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: BudgetActions.RESET_DATA,
      };
    }
    static resetList(){
      return {
        type: BudgetActions.RESET_LIST,
      };
    }
  static helper(data){
    return{
      type : BudgetActions.GET_HELPER,
      payload : data
    };

  }
    static errorInternal(error){
      return {
        type: BudgetActions.ERROR_SERVER,
        payload: error
      };
    }
  }